import React from 'react';
import { Col, Row, VertTypography } from '@vertem-core/vertice-ds';
import PropTypes from 'prop-types';

const FilterWrapper = ({ title, className, children }) => {
  return (
    <Row justify="center" align="middle" className={`vert-box-filter vert-box-filter vert-box-filter-title margin-top-small padding-bottom-small ${className}`} gutter={8}>
      { title !== '' && (
      <Col span={24} className="margin-bottom-small">
        <VertTypography.Title level={2} className="margin-bottom-none">
          {title}
        </VertTypography.Title>
      </Col>
      )}
      <Col span={24}>
        { children }
      </Col>
    </Row>
  );
};

FilterWrapper.propTypes = {
  title: PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node.isRequired,
};
export default FilterWrapper;
